import { Button, Grid, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import img from "../../../Images/contact.png";
import "./Contact.css"

const Contact = () => {
  
  return (
    <div className='contact-container'>
      <Grid container spacing={2}>
        <Grid item sm={12} md={3} sx={{ display: { xs: "none", md: "block" } }}>
          <img src={img} className="contact-image" alt="" />
        </Grid>
        <Grid item sm={12} md={9}>
          <p className="contact-info mail">mr.ashraful2020@gmail.com</p>
          <p className="contact-info phone"> (+880)- 1789427304</p>

          <form>
            <Box sx={{ display: { xs: "block", md: "flex" } }}>
              <TextField
                id="standard-basic"
                variant="standard"
                style={{ width: "87%",margin: "4%"}}
                placeholder="Enter your name..........."
                required
              />
              <TextField
                id="standard-basic"
                variant="standard"
                style={{ width: "87%",margin: "4%" }}
                placeholder="mail@domain.com"
                required
              />
            </Box>
            <TextField
              id="standard-basic"
              variant="standard"
              style={{ width: "87%",margin: "4%"}}
              placeholder="Subject (optional)"
              required
            />
            <TextField
              id="standard-basic"
              variant="standard"
              style={{ width: "87%",margin: "4%"}}
              placeholder="Enter your name"
              multiline
              rows={4}
              required
            />
            <Button type="submit" variant="outlined" color="warning"> Send Message</Button>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Contact;
